import { useEffect, useState } from "react";
import { realtime } from "../lib/ws";

/**
 * After a deploy, a page left open still runs the code it was loaded with, and what it offers can be refused by
 * the new platform. This says so the moment the platform is replaced, and reloads on a click.
 */
export function UpdateToast() {
  const [updated, setUpdated] = useState(realtime.updated);
  useEffect(() => realtime.onUpdate(() => setUpdated(true)), []);
  if (!updated) return null;
  return (
    <div role="status" className="fixed inset-x-0 top-16 z-50 mx-auto flex w-fit max-w-[calc(100%-2rem)] items-center gap-3 rounded-full bg-ink py-2 pr-2 pl-4 text-sm text-paper shadow-lg dark:bg-white dark:text-ink">
      <span>AgentOS has been updated.</span>
      <button type="button" className="rounded-full bg-white/15 px-3 py-1 font-medium hover:bg-white/25 dark:bg-black/10 dark:hover:bg-black/20" onClick={() => location.reload()}>
        Reload
      </button>
    </div>
  );
}
